<template >
  <b-container fluid>

    <b-row align-h="center" >
      <b-col cols="11" sm="11" md="11" lg="11" xl="11"  class="card-form-primary mt-5 ">
        <b-row  style="cursor:pointer;">
          <b-col class="mt-3 mb-2">
            <h5 style="color:#312bb5; text-transform:capitalize;"><b-icon icon="files"/> Catálogos Catastrales</h5>
            <!-- <h6 style="color: gray; text-transform:capitalize;">{{formasFormModel.inSelectTipoBusqueda.model.toLowerCase()}}</h6> -->
          </b-col>          
        </b-row>

        <!-- Vialidades -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-1'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Vialidades</b-button>
            <b-collapse id="collapse-1" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-row >
                <b-col>
                  <b-table sort-icon-left style="font-size: 85%; " hover  responsive  striped small sticky-header  :items="catalogoAdmin.vialidades" :fields="fieldsVialidades">
                    <template #cell(acciones)="row">
                      <b-icon style="cursor:pointer;" @click="row.toggleDetails" icon="pencil-square" />
                    </template>

                    <template #row-details="row">
                      <b-card>
                        <b-row class="mb-2">
                          <b-col cols="12">
                            <h6>Editar nombre de la vialidad</h6>
                          </b-col>
                          <b-col class="text-sm-right">
                            <b-form-input v-model="row.item.nombre"></b-form-input>
                            <b-button v-if="!editandoCats" size="sm" variant="success" @click="editarNombreCalle(row.item)">Guardar</b-button>
                            <b-spinner v-if="editandoCats" small variant="success"></b-spinner>
                          </b-col>
                        </b-row>
                        
                      </b-card>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-collapse>
          </b-col>
        </b-row>
        <!-- Colonias -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-colonias'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Colonias</b-button>
            <b-collapse id="collapse-colonias" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-row >
                <b-col>
                  <b-table sort-icon-left style="font-size: 85%; " hover  responsive  striped small sticky-header  :items="catalogoAdmin.colonias" :fields="fieldsColonias">                    
                  </b-table>
                </b-col>
              </b-row>
            </b-collapse>
          </b-col>
        </b-row>
        <!-- Localidades -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-localidades'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Localidades</b-button>
            <b-collapse id="collapse-localidades" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-row >
                <b-col>
                  <b-table sort-icon-left style="font-size: 85%; " hover  responsive  striped small sticky-header  :items="catalogoAdmin.localidades" :fields="fieldsLocalidades">
                  </b-table>
                </b-col>
              </b-row>
            </b-collapse>
          </b-col>
        </b-row>
        <!-- Manzanas -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-manzanas'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Manzanas</b-button>
            <b-collapse id="collapse-manzanas" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-tabs>
                <b-tab :title="cat.año.toString()" v-for="cat in catalogoAdmin.manzanas" :key="cat.año">
                  <b-row >
                    <b-col>
                      <b-table sort-icon-left style="font-size: 85%; " hover  responsive  striped small sticky-header  :items="cat.cats" :fields="fieldsManzanas">                        
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-collapse>
          </b-col>
        </b-row>
        <!-- Areas Homogeneas -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-areash'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Areas Homogeneas</b-button>
            <b-collapse id="collapse-areash" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-tabs>
                <b-tab :title="cat.año.toString()" v-for="cat in catalogoAdmin.areasH" :key="cat.año">
                  <b-row >
                    <b-col>
                      <b-table sort-icon-left style="font-size: 85%; " hover  responsive  striped small sticky-header  :items="cat.cats" :fields="fieldsAreasH">                        
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-collapse>
          </b-col>
        </b-row>
        <!-- Bandas de Valor -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-bandas'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Bandas de Valor</b-button>
            <b-collapse id="collapse-bandas" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-tabs>
                <b-tab :title="cat.año.toString()" v-for="cat in catalogoAdmin.bandasValor" :key="cat.año">
                  <b-row >
                    <b-col>
                      <b-table sort-icon-left style="font-size: 85%; " hover  responsive  striped small sticky-header  :items="cat.cats" :fields="fieldsBandasValor">                        
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-collapse>
          </b-col>
        </b-row>

        <!-- Valores Unitarios -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-valoresc'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Valores de Construccion</b-button>
            <b-collapse id="collapse-valoresc" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-tabs>
                <b-tab :title="cat.año.toString()" v-for="cat in catalogoAdmin.valoresUniConstruccion" :key="cat.año">
                  <b-row >
                    <b-col>
                      <b-table sort-icon-left style="font-size: 85%; " hover  responsive  striped small sticky-header  :items="cat.cats" :fields="fieldsValoresUni">                        
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-collapse>
          </b-col>
        </b-row>

        <!-- Reportes -->
        <b-row class="mb-3">
          <b-col>
            <b-button block v-b-toggle="'collapse-repc'" variant="secondary" style="text-align:left;"><b-icon icon="list-ul"/> Reportes</b-button>
            <b-collapse id="collapse-repc" style="width: 100%;" accordion="my-accordion" role="tabpanel">
              <b-tabs class="mt-4">
                <b-tab title="Generar DBF">
                  <b-row class="mt-4" >
                    <b-col>
                      <h6>Año: </h6><b-input placeholder="Ingrese el año" v-model="añoDbf" type="number"></b-input>
                      <h6>Mes: </h6><b-input placeholder="Ingrese el mes" v-model="mesDbf" type="number"></b-input>
                      <div class="mt-4"></div>
                      <b-button variant="success" @click="genDbfs">Generar DBFS <b-spinner v-if="generandoDbfs"></b-spinner></b-button>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-collapse>
          </b-col>
        </b-row>

      </b-col>
    </b-row>

  </b-container>
</template>

<script>
  import Vue from 'vue';
  import { mapState} from 'vuex';
  import JsonExcel from 'vue-json-excel';
   import { server, server2, checkAuth, getPostConfig, handledError } from '@/axios-tools';
  import axios from 'axios';
  // import { minLength, maxLength, required, requiredIf } from 'vuelidate/lib/validators';64444
  Vue.component('downloadExcel', JsonExcel);

  export default {
    computed: {
      ...mapState({
        token: state => state.login.token,
        catalogoAdmin: state => state.admin.catalogoAdmin,
      }),

    },
    components: {
    },
    mounted() {
      if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);
      }
      window.scrollTo(0, 0);
      
    },
    data() {
      return {
        generandoDbfs : false,
        añoDbf : null,
        mesDbf : null,
        editandoCats : false,
        fieldsAreasH : [
              {key: 'areaH', label: 'Codigo', sortable: true},
              {key: 'frenteAreaH', label: 'Frente', sortable: true},                          
              {key: 'fondoAreaH', label: 'Fondo', sortable: true},
              {key: 'fondoAreaH', label: 'Fondo', sortable: true},
              {key: 'valM2AreaH', label: 'Valor M2', sortable: true},
              {key: 'descAreaH', label: 'Descripcion', sortable: true},
            ],
          fieldsBandasValor : [
              {key: 'id', label: 'ID', sortable: true},
              {key: 'codCalle', label: 'ID Calle', sortable: true},                          
              {key: 'valM2', label: 'Valor M2', sortable: true},
              {key: 'zonaOrigen', label: 'Zona', sortable: true},
              {key: 'manzana', label: 'Manzana', sortable: true},
            ],
          fieldsManzanas : [
              {key: 'manzana', label: 'Manzana', sortable: true},                          
              {key: 'areaH', label: 'Area Homogenea', sortable: true},
            ],
          fieldsValoresUni : [
              {key: 'uso', label: 'Uso', sortable: true},                          
              {key: 'clase', label: 'Clase', sortable: true},
              {key: 'categoria', label: 'Categoria', sortable: true},
              {key: 'descripcion', label: 'Descripcion', sortable: true},
              {key: 'valorM2', label: 'Valor M2', sortable: true},
            ],
          fieldsVialidades : [
              {key: 'id', label: 'ID', sortable: true},                          
              {key: 'codigo', label: 'Codigo', sortable: true},
              {key: 'codZona', label: 'Zona', sortable: true},
              {key: 'tipo', label: 'Tipo', sortable: true},
              {key: 'nombre', label: 'Nombre', sortable: true},              
              {key: 'acciones', label: 'Editar', sortable: true}, 
            ],
            fieldsColonias : [
              {key: 'numColonia', label: 'ID', sortable: true},         
              {key: 'nombreColonia', label: 'Nombre', sortable: true},              
            ],
            fieldsLocalidades : [
              {key: 'numLocalidad', label: 'ID', sortable: true},         
              {key: 'nombreLocalidad', label: 'Nombre', sortable: true},              
            ],
        windowWidth: window.innerWidth
      }
    },
    methods: {
      editarNombreCalle(vialidadCat){
        if(!this.editandoCats && checkAuth(this.$router, this.$store)){
          this.editandoCats = true;
          axios(
              getPostConfig(server.editanombrecalle, vialidadCat, this.token, null)            
              ).then(() => {
                this.editandoCats = false;
                alert('El nombre de la calle fue editado correctamente.');
              }).catch(err => {
                this.editandoCats = false;
                handledError(err, server.editanombrecalle, this.$router, this.$store);
              })
          
        }
      },
      genDbfs(){
        if(!this.editandoCats && checkAuth(this.$router, this.$store) && !this.generandoDbfs){
          this.generandoDbfs = true;
          axios(
              getPostConfig(server2.gendbfs, {}, this.token, {año: this.añoDbf, mes:this.mesDbf})            
              ).then(res => {
                this.generandoDbfs = false;
                for(let idx in res.data){
                  let data= 'data:application/octet-stream;base64,'+res.data[idx].b64;              
                  let downloadExcel = document.createElement('a');
                  downloadExcel.setAttribute('href', data);
                  downloadExcel.setAttribute('download', res.data[idx].name);
                  downloadExcel.click();  
                }
              }).catch(err => {
                this.generandoDbfs = false;
                handledError(err, server2.gendbfs, this.$router, this.$store);
              })
          
        }
      }
    },
    validations:{
      
    }
  }
</script>
<style>
.button-margin {margin: 30px 0%;}
.row-margin {margin: 5px auto;}
.button-add-contrib{
  margin-bottom:10px;
}
</style>